import axios from 'axios';
import { mapApiUtcToPolishTime, mapPolishTimeToApiUtc } from '../../utils/dateTime';

const AUTH_TOKEN = process.env.REACT_APP_API_AUTH_TOKEN;

const gusApi = axios.create({
    baseURL: `/api`,
    headers: {
        'Accept': '*/*',
        'Authorization': `Basic ${AUTH_TOKEN}`
    }
});

// GUS korzysta z osobnej instancji Axios, więc utrzymujemy ten sam kontrakt
// dat jak dla głównego API panelu.
gusApi.interceptors.request.use((config) => {
    config.data = mapPolishTimeToApiUtc(config.data);
    config.params = mapPolishTimeToApiUtc(config.params);
    return config;
});

gusApi.interceptors.response.use((response) => {
    response.data = mapApiUtcToPolishTime(response.data);
    return response;
});

export const fetchFirmaByNip = async (nip) => {
    try {
        const response = await gusApi.get(`/gus/firma/nip/${nip}`);
        return response.data;
    } catch (error) {
        console.error('Błąd podczas pobierania danych z GUS:', error);
        throw error;
    }
};

const gusService = {
    fetchFirmaByNip
};

export default gusService;
